import script from "./phone.vue?vue&type=script&lang=js"
export * from "./phone.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/components/form/horizontal/phone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67f0bc5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67f0bc5e', __exports__)) {
    console.log('reload')
    api.reload('67f0bc5e', __exports__)
  }
  
}


export default __exports__